import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import About from "@/components/About";
import IrregularBlocks from "@/components/IrregularBlocks";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Projects from "@/components/Projects";
import Reviews from "@/components/Reviews";
import Gallery from "@/components/Gallery";
import Process from "@/components/Process";
import DreamHome from "@/components/DreamHome";
import Marquee from "@/components/Marquee";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import LocationMap from "@/components/LocationMap";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";

export default function HomePage() {
  return (
    <div id="top" className="bg-cream text-charcoal antialiased overflow-x-hidden">
      <Navbar />
      <main className="pb-14 md:pb-0">
        <Hero />
        <TrustStrip />
        <About />
        <IrregularBlocks />
        <Services />
        <WhyUs />
        <Projects />
        <Reviews />
        <Gallery />
        <Process />
        <DreamHome />
        <Marquee />
        <Faq />
        <Contact />
        <LocationMap />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
